import axios from 'axios'

const STORAGE_KEY = 'valizo_pricing_session_id'

function generateSessionId() {
  return `ps_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`
}

export function getPricingSessionId() {
  try {
    const fromStorage = window.localStorage.getItem(STORAGE_KEY)
    if (fromStorage) {
      return fromStorage
    }

    const nextValue = generateSessionId()
    window.localStorage.setItem(STORAGE_KEY, nextValue)
    return nextValue
  } catch (e) {
    return generateSessionId()
  }
}

export async function requestPricingQuote(payload) {
  const apiBase = process.env.VUE_APP_API_URL || 'https://backend.valizo.eu/wp-json/api'
  const response = await axios.post(`${apiBase}/pricing/quote`, payload)
  return response.data
}

export async function validatePricingCheckout(payload) {
  const apiBase = process.env.VUE_APP_API_URL || 'https://backend.valizo.eu/wp-json/api'
  const response = await axios.post(`${apiBase}/pricing/checkout`, payload)
  return response.data
}
